import { render, staticRenderFns } from "./CartPage.vue?vue&type=template&id=d23ae73a&"
import script from "./CartPage.vue?vue&type=script&lang=ts&"
export * from "./CartPage.vue?vue&type=script&lang=ts&"
import style0 from "./CartPage.vue?vue&type=style&index=0&id=d23ae73a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports